import React from 'react';
import {updateSelectedLocation, updatePrefillMessage, updateOptionalMessage, updateSelectedGang, fetchLocations} from '../../actions/alert_actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Modal from './modal';
import { SMS_MESSAGES } from '../../constants';


class Form extends React.Component {

  componentDidMount() {
    //display all employees by default and get possible locations to select
    this.props.updateSelectedLocation("All");
    this.props.fetchLocations();
  }

  componentDidUpdate() {
    //if gang, location, and a prefill or option message are all filled in, allow message to be sent
    if (this.props.gang && this.props.location && (this.props.prefillMessage || this.props.optionalMessage)) {
      document.getElementById('modalBtn').disabled = false;
    } else {
      document.getElementById('modalBtn').disabled = true;
    }
  }


  renderGangOptions() {
    //render list of gang options from state
    return this.props.gangOptions.map((opt,i) => {
      if (opt.gangCount) {
        return <option key={i.toString()} value={opt.gangId}>{opt.gangId}</option>
      }
      return null;
    })
  }

  renderLocationOptions() {
    //render list of location options from state
    return this.props.locationOptions.map((opt,i) => {
      return <option key={i.toString()} value={opt.location}>{opt.location} - {Number(opt.location) === 71 ? "Kau" : "Keaau"}</option>
    })
  }

  render() {


    return (
      <div className={this.props.className}>
        <br />
        <form className="messageForm" onSubmit={(e) => e.preventDefault()}>
          {/******* Select Location *******/}
          <div className="input-field col s12 m6">
            <label className="active">Location:</label>
            <select className="browser-default" defaultValue="" id="location" onChange={(e) => {this.props.updateSelectedLocation(e.target.value)}}>
              <option value = "" disabled>Select Location</option>
              <option value = "All">All Locations</option>
              {this.renderLocationOptions()}
            </select>
          </div>
          {/******* Select Department *******/}
          <div className="input-field col s12 m6">
            <label className="active">Gang:</label>
            <select className="browser-default" defaultValue="" id="department" onChange={(e) => {this.props.updateSelectedGang(this.props.location,e.target.value)}}>
              <option value = "" disabled>Select Gang</option>
              <option value="All">All Gangs</option>
              {this.renderGangOptions()}
            </select>
          </div>
          {/******* Select Location *******/}
          <div className="input-field col s12">
            <select className="browser-default" defaultValue="" id="messages" onChange={(e) => {this.props.updatePrefillMessage(e.target.value)}}>
              <option value = "" disabled>Select Message</option>
              {
                SMS_MESSAGES.map((m) => (
                  <option key={m.msg} value={m.msg}>{m.value}</option>
                ))
              }
            </select>
            <p id="selectedMessageText">{this.props.prefillMessage}</p>
          </div>
          {/******* Enter Message *******/}
          <div className="input-field col s12">
            <label htmlFor='messageInput'>
              Optional additional information
            </label>
            <input
              onChange= {(e) => {this.props.updateOptionalMessage(e.target.value)}}
              className="validate"
              id='messageInput'
              type='text'
            />
          </div>
          <button id="modalBtn" data-target="finalModal" className="btn modal-trigger modalBtn">Send Message</button>
        </form>
        <Modal id={'finalModal'} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    location: state.form.location,
    prefillMessage: state.form.prefillMessage,
    optionalMessage: state.form.optionalMessage,
    gangOptions: state.form.gangOptions,
    locationOptions: state.form.locationOptions,
    gang: state.form.gang
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    updateSelectedLocation,
    updatePrefillMessage,
    updateOptionalMessage,
    updateSelectedGang,
    fetchLocations,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Form);



// WEBPACK FOOTER //
// ./src/components/alert/location-form.js